module.exports = __webpack_public_path__ + "img/t5-blue.f1151946.png";